import { render } from "./SaveHoliday.vue?vue&type=template&id=1b6b7b05&scoped=true"
import script from "./SaveHoliday.vue?vue&type=script&lang=js"
export * from "./SaveHoliday.vue?vue&type=script&lang=js"

import "./holiday.scss?vue&type=style&index=0&id=1b6b7b05&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b6b7b05"]])

export default __exports__